import * as React from 'react';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup } from '../../uiComponents/input/FormGroups';
import { SectionDynamic } from '../../uiComponents/layout/SectionDynamic';
import { DelopgaveBedoemmelsesFaktor } from '../../models/DelopgaveBedoemmelsesFaktor';
import { ValidationError } from '../../infrastructure/ValidationResult';

export interface BedoemmelsesFaktorComponentProps {
    bedommelsesFaktor: DelopgaveBedoemmelsesFaktor;
    index: number;
    delopgaveIndex: number;
    removeBedoemmelsesFaktor: (key: any, delopgaveIndex: number) => void;
    onBedoemmelsesFaktorChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number) => void;    
    errorMessages: ValidationError[];
}

export interface BedoemmelsesFaktorComponentState {
    label: string;
}

class BedoemmelsesFaktorComponent extends React.Component<BedoemmelsesFaktorComponentProps, BedoemmelsesFaktorComponentState> {
    constructor(props: BedoemmelsesFaktorComponentProps) {
        super(props);
        this.onChange = this.onChange.bind(this);

        let label = 'Bedømmelsesfaktor ';
        const currentLength = this.props.bedommelsesFaktor.titel != null ? this.props.bedommelsesFaktor.titel.length : 0;
        const karaktererTilbage = 300 - currentLength;
        label += ' (' + karaktererTilbage + ' karakterer tilbage)';

        const state = {
            label: label
        };

        this.state = state;

        this.onChange = this.onChange.bind(this);
    }

    onChange(field: string, value: string) {
        this.setLabel(value);

        this.props.onBedoemmelsesFaktorChanged(field, value, this.props.index, this.props.delopgaveIndex);
    }

    render() {
        return (
            <div>
                <SectionDynamic index={this.props.index} deleteOnClick={() => this.props.removeBedoemmelsesFaktor(this.props.index, this.props.delopgaveIndex)}>
                    <Row>
                        <Col md={10} mdOffset={1}>
                            <TextFormGroup
                                errorMessages={this.props.errorMessages}
                                label={this.state.label}
                                name='titel'
                                placeholder='Beskrivelse af bedømmelsesfaktor'
                                value={this.props.bedommelsesFaktor.titel}
                                onChange={this.onChange}
                                maxlength={300}
                            />
                        </Col>
                    </Row>
                </SectionDynamic>
            </div>
        );
    }

    private setLabel(value: string) {
        let label = 'Bedømmelsesfaktor ';
        const karaktererTilbage = 300 - value.length;
        label += ' (' + karaktererTilbage + ' karakterer tilbage)';
        this.setState({ label: label });
    }
}

export default BedoemmelsesFaktorComponent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/BedoemmelsesFaktorComponent.tsx